import HealthCheckups from '../../pages/AuthPages/HealthChecks';
import HraPage from '../../pages/AuthPages/HraPage';
import DoctorConsultation from '../../pages/AuthPages/DoctorConsultation';
import HealthRisk from '../../pages/AuthPages/HealthRisk';
import TestResult from '../../pages/AuthPages/TestResult';
import Engagement from '../../pages/AuthPages/Engagement';
import ManageEmploye from '../../pages/AuthPages/ManageEmploye';
import OHCManagement from '../../pages/AuthPages/OHCManagement';
import Help from '../../pages/AuthPages/Help';
import ProfilePage from '../../pages/AuthPages/Profile';
import Setting from '../../pages/AuthPages/Setting';

import allModules from './modules';

export type RouteConfig = {
  path: string;
  component: React.FC;
  moduleName?: string;
  permission?: 'view' | 'edit';
};

export const protectedRoutes: RouteConfig[] = [
  {
    path: 'myaccount/profile',
    component: ProfilePage,
    moduleName: allModules.profile,
    permission: 'view',
  },

  {
    path: 'utilization/health-checks',
    component: HealthCheckups,
    moduleName: allModules.healthCheckup,
    permission: 'view',
  },
  {
    path: 'utilization/hra',
    component: HraPage,
    moduleName: allModules.hra,
    permission: 'view',
  },
  {
    path: 'utilization/consultation',
    component: DoctorConsultation,
    moduleName: allModules.drConsultation,
    permission: 'view',
  },

  {
    path: 'analytics/health-risk',
    component: HealthRisk,
    moduleName: allModules.healthRisks,
    permission: 'view',
  },
  {
    path: 'analytics/test-result',
    component: TestResult,
    moduleName: allModules.testResult,
    permission: 'view',
  },

  {
    path: 'engagement',
    component: Engagement,
    moduleName: allModules.engagement,
    permission: 'view',
  },
  {
    path: 'manage-employee',
    component: ManageEmploye,
    moduleName: allModules.manageEmployee,
    permission: 'view',
  },
  {
    path: 'ohc-management',
    component: OHCManagement,
    moduleName: allModules.ohcManagement,
    permission: 'view',
  },
  {
    path: 'help',
    component: Help,
    moduleName: allModules.help,
    permission: 'view',
  },

  {
    path: 'myaccount/settings',
    component: Setting,
    moduleName: allModules.setting,
    permission: 'view',
  },
];
